// extracted by mini-css-extract-plugin
export default {"SwipeableRoot":"NavSidebar_SwipeableRoot__7fpJm","Paper":"NavSidebar_Paper__DGL6Y","ItemsWrapper":"NavSidebar_ItemsWrapper__UiqJm","BottomWrapper":"NavSidebar_BottomWrapper__RFpzq"};